import { createBaseQuery } from 'shared/api/rtk-query';
import { DownloadFileDto, ParsedEmailsDto } from '@sr/dto';
import { createApi } from '@reduxjs/toolkit/query/react';

type ParsedEmailQuery = { id: number; leadId?: number };
type EmailAttachmentsQuery = { ids: number[]; leadId?: number };

export const parsedEmailApi = createApi({
  reducerPath: 'parsedEmailApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['*'],
  endpoints: (builder) => {
    return {
      getParsedEmail: builder.query<ParsedEmailsDto, ParsedEmailQuery>({
        query: ({ id, leadId }) => ({
          url: leadId ? `lead/${leadId}/email` : `email-parser/${id}`,
          method: 'GET',
        }),
        providesTags: ['*'],
      }),
      getEmailAttachments: builder.query<DownloadFileDto[], EmailAttachmentsQuery>({
        query: ({ ids, leadId }) => ({
          url: leadId ? `lead/${leadId}/email/attachments` : `files?ids=${ids}`,
          method: 'GET',
        }),
        providesTags: ['*'],
      }),
    };
  },
});
